// External Libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';
import { updateCountryFunc } from '../../../store/custom-actions/countries-actions/UpdateCountrySlicer';


function UpdateCountryForm({ show, onHide, countryId, oldName, oldCode, oldStatus }) {
  const { t } = useTranslation();
  const { register, reset, formState: { errors }, handleSubmit, setValue } = useForm();
  const { loading: submitLoading } = useSelector(state => state.updateCountrySlicer);
  const dispatch = useDispatch();
  useEffect(() => {
    setValue("name", oldName);
    setValue("code", oldCode);
    setValue("active", oldStatus);
  }, [setValue, oldName, oldCode, oldStatus])

  const resetForm = () => {
    reset();
    onHide();
  };

  const onSubmit = async (data) => {
    const payload = { ...data };
    const result = await dispatch(updateCountryFunc({ id: countryId, data: payload }));
    if (updateCountryFunc.fulfilled.match(result)) {
      dispatch(getCountriesFunc())
      resetForm();
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{t('Update')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-update"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormField
              label="Country"
              name="name"
              register={register}
              required={true}
              errors={errors}
            />
            <FormField
              label="Code"
              name="code"
              register={register}
              required={true}
              errors={errors}
            />
            <CheckboxField
              name="active"
              label="Activity"
              register={register}
              errors={errors}
              defaultChecked={true}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t('Close')}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-update"
          />
        </Modal.Footer>
      </Modal>
    </>
  );

}

export default UpdateCountryForm;